module.exports = __webpack_public_path__ + "img/54.797f505a.jpg";